import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MapPin, Sparkles, Heart } from 'lucide-react';
import { Button } from '../ui/button';

export const Hero2027 = ({ edicao, periodo, local }) => (
  <section className="relative min-h-[88vh] flex items-center overflow-hidden pt-24 pb-20" data-testid="hero-2027">
    <div className="absolute inset-0 bg-[var(--ds-background)]" />
    <img src="/hero-kairos-2026.webp" alt="Casais participantes do Encontro Kairós 2026" className="absolute inset-0 w-full h-full object-cover object-center opacity-45" fetchPriority="high" data-testid="hero-bg-image" />
    <div className="absolute inset-0 bg-gradient-to-r from-[var(--ds-background)] via-[var(--ds-background)]/85 to-[var(--ds-background)]/30" />
    <div className="absolute inset-0 bg-gradient-to-t from-[var(--ds-background)] via-transparent to-transparent" />
    <div className="absolute -top-20 -left-20 w-[520px] h-[520px] bg-kairos-orange/15 rounded-full blur-[140px] animate-pulse" style={{ animationDuration: '6s' }} />

    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-3xl">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-kairos-orange/15 border border-kairos-orange/40 mb-8 animate-fade-in-up" data-testid="hero-selo">
          <Sparkles className="w-4 h-4 text-kairos-orange" />
          <span className="text-kairos-orange text-xs sm:text-sm font-semibold tracking-[0.2em]">PRÉ-INSCRIÇÕES ABERTAS</span>
        </div>

        <p className="text-gray-400 text-xs sm:text-sm tracking-[0.3em] mb-4 animate-fade-in-up">SEMINÁRIO PSICOTEOLÓGICO</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.08] tracking-tight mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }} data-testid="hero-title">
          KAIRÓS {edicao.ano} — <span className="text-transparent bg-clip-text bg-gradient-to-r from-kairos-orange to-kairos-orange-light">UMA NOVA OPORTUNIDADE DE FORTALECER O AMOR</span>
        </h1>
        <p className="text-gray-300 text-base md:text-lg leading-relaxed max-w-2xl mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }} data-testid="hero-subtitle">
          De {periodo}, preparem-se para viver quatro dias de conexão, aprendizado e renovação do relacionamento.
        </p>

        <div className="flex flex-wrap items-center gap-3 mb-10 animate-fade-in-up" style={{ animationDelay: '0.25s' }}>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-200 text-sm" data-testid="hero-data">
            <Calendar className="w-4 h-4 text-kairos-orange" /> {periodo}
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-200 text-sm" data-testid="hero-local">
            <MapPin className="w-4 h-4 text-kairos-orange" /> {local}
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-200 text-sm">
            <Heart className="w-4 h-4 text-kairos-orange" /> Exclusivo para casais
          </span>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <Link to="/pre-inscricao" data-testid="hero-cta-pre-inscricao">
            <Button className="h-auto min-h-14 py-3 px-6 sm:px-8 rounded-full bg-gradient-to-r from-kairos-orange to-kairos-orange-light text-white font-semibold text-sm sm:text-base whitespace-normal max-w-full shadow-[0_0_40px_rgba(255,107,0,0.35)] hover:shadow-[0_0_60px_rgba(255,107,0,0.55)] hover:scale-[1.03] transition-all w-full sm:w-auto">
              QUERO FAZER NOSSA PRÉ-INSCRIÇÃO
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
          <a href="#sobre" data-testid="hero-cta-conhecer">
            <Button variant="outline" className="h-14 px-8 rounded-full border-white/20 text-white hover:bg-white/5 hover:border-kairos-orange/50 font-medium text-base w-full sm:w-auto">
              CONHECER O KAIRÓS
            </Button>
          </a>
        </div>
        <p className="text-gray-500 text-sm mt-6" data-testid="hero-lote-aviso">{edicao.lote_mensagem}</p>
      </div>
    </div>
  </section>
);
